export default __webpack_public_path__ + "static/media/placeimg_640_480_tech.d4a30f97.jpg";